import { SectionHeader } from "./section-header";
import { SidebarMenuRoot, SidebarMenuSection } from "./sidebar-menu";

/**
 * SidebarMenu — vertical, expandable navigation rail.
 *
 * Composes one or more `SidebarMenu.Section` blocks (each with an optional
 * `SidebarMenu.SectionHeader` + a list of `SidebarNavItem` rows) and renders
 * dividers between sections automatically.
 *
 * The `collapsed` flag lives on the root and propagates through
 * `SidebarMenuContext` to every descendant `SidebarNavItem` — consumers do
 * not thread it manually. The organism is positioning-agnostic: width
 * transitions, drawer chrome, and page layout live in the consumer.
 *
 * @see docs/tickets/DS-042-sidebar-menu.md
 */
export const SidebarMenu = Object.assign(SidebarMenuRoot, {
  Section: SidebarMenuSection,
  SectionHeader,
});

export type { SectionHeaderProps, SidebarMenuProps, SidebarMenuSectionProps } from "./types";
